import React from "react";
import styles from "../offlinePay.module.css";
import { Card, Col, Row } from "react-bootstrap";
import CommonButton from "../../CommonButton/CommonButton";
import downloadIcon from "../../../public/assets/download-icon.png";
import '@react-pdf-viewer/core/lib/styles/index.css';
import pdfImage from '../../../public/assets/pdfImage.svg'

function OfflineDownloadDocuments({ stepToShowOffline, setStepToShowOffline }) {
  const SanctionspdfUrl = '/sanctionsDeclaration.pdf';
  const revisedA2pdfUrl = '/revisedA2Form.pdf'

  const handleDownload = (label) => {
    let url = '';
    let fileName = '';
    
    if (label === "Sanctions Declaration") {
      url = SanctionspdfUrl;
      fileName = "sanctionDeclaration.pdf";
    } else if (label === "Revised A2 form") {
      url = revisedA2pdfUrl;
      fileName = "revisedA2form.pdf";
    }

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className={styles.cardDetails}>
      <>
        <h1 className={styles.onboardHeading}>3. OFAC Sanction Letter and A2 Form</h1>
        <Card className={styles.cardAccount}>
          <Card.Body className={styles.cardBodyAccount}>
            <Row className={styles.Title}>Download Documents</Row>
            {stepToShowOffline >= 5 ? (
              <>
                <hr style={{ marginTop: "0px" }} />
                <div style={{ marginTop: "20px" }}>
                  <Row
                    style={{ marginBottom: "8px", justifyContent: "center" }}
                  >
                    <Col
                      md={12}
                      sm={12}
                      xs={12}
                      lg={4}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "10px 0px",
                      }}
                    >
                      <div className={styles.title}>
                        <div
                          onClick={() => handleDownload("Sanctions Declaration")}
                          className={styles.downloadDiv}
                        >
                          <div className={styles.uploadedImageDiv}>
                            <img
                              src={pdfImage}
                              className={styles.uploadedImage}
                              alt="Uploaded Preview"
                            />
                          </div>
                          <div className={styles.labelDiv}>
                            <img
                              src={downloadIcon}
                              alt="Download Icon"
                              className={styles.dwnldImageIcon}
                            />
                            <p className={styles.label}>{"OFAC Sanction Letter"}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col
                      md={12}
                      sm={12}
                      xs={12}
                      lg={4}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "10px 0px",
                      }}
                    >
                      <div className={styles.title}>
                        <div
                          onClick={() => handleDownload("Revised A2 form")}
                          className={styles.downloadDiv}
                        >
                          <div className={styles.uploadedImageDiv}>
                            <img
                              src={pdfImage}
                              className={styles.uploadedImage}
                              alt="Uploaded Preview"
                            />
                          </div>
                          <div className={styles.labelDiv}>
                            <img
                              src={downloadIcon}
                              alt="Download Icon"
                              className={styles.dwnldImageIcon}
                            />
                            <p className={styles.label}>{"A2 form"}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className={styles.allowedFormat} style={{display: "flex"}}>
                  Please download the OFAC Sanction Letter and A2 Form, and physically fill in the details to submit at next step.
                </div>
                <div className={styles.allowedFormat} style={{marginTop: "6px", display: "flex"}}>
                <div md={1} style={{color: "red", fontSize: "16px", paddingRight: "0px", textAlign: "end", marginRight: "10px"}}>Note: </div>
                <div>Please ensure all details in the A2 form and OFCA Sanction letter are correct and sign the documents on each page for self attestation.</div>
                </div>
                {stepToShowOffline === 5 && <Row className="pt-3 mt-3">
                  <Col md={3}>
                    <CommonButton
                      title="Next"
                      onClick={() => setStepToShowOffline(6)}
                      width={"150px"}
                    />
                  </Col>
                </Row>}
              </>
            ) : (
              ""
            )}
          </Card.Body>
        </Card>
      </>
    </div>
  );
}

export default OfflineDownloadDocuments;